/* eslint-disable no-case-declarations */
/* eslint-disable eqeqeq */
export const types = {
  DRAFT_POST: 'DRAFT_VOD',
  PUT: 'UPDATE_VOD',
  DELETE: 'DELETE_VOD',
  RESET: 'RESET_VOD',
  RELOAD: 'RELOAD_VOD',
};

export const getDraftId = () => '';

export const vodReducer = (state = [], action) => {
  switch (action.type) {
    case types.DRAFT_POST:
      return [
        ...state,
        { ...action.payload },
      ];
    case types.PUT:
      return state.map((child) => (child.id == action.payload.id ? action.payload : child));
    case types.DELETE:
      const newValues = [...state];
      const index = newValues.indexOf(action.item);
      newValues.splice(index, 1);
      return newValues;
    case types.RELOAD:
      return action.payload;
    case types.RESET:
      return [];
    default:
      return state;
  }
};
